/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const childRoutes = [];

childRoutes[childRoutes.length] = {
    path: '/shareyourstory/story-gallery',
    componentName: 'StoryGallery',
    requireAuth: false,
};

childRoutes[childRoutes.length] = {
    path: '/shareyourstory/story/:slug/:storyId',
    componentName: 'Story',
    requireAuth: false,
};

// USE THIS PATH WHEN THE CONTEST IS OVER
childRoutes[childRoutes.length] = {
    path: '/shareyourstory',
    componentName: 'StoryGallery',
    requireAuth: false,
};

export default childRoutes;
